import Vue from "vue";
import Vuex from 'vuex'

import adminUser from './adminUser'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        admin: adminUser
    }
})


// WEBPACK FOOTER //
// ./src/store/store.js